module.exports = __webpack_public_path__ + "static/media/exercicios-active.848f8c01.png";